import React, { useEffect, useState } from 'react'
import { useParams, Link } from "react-router-dom";

import loader from '../images/gif/loading-gear.gif'

export default function SingleMeal() {
    const {id}  = useParams()
    const [loading, setLoading] = React.useState(false);
    const [meal, setMeal] = React.useState(null);

    useEffect(() => {
        setLoading(true);
        async function getMeal() {
            try {
                const response = await fetch(`https://www.themealdb.com/api/json/v1/1/lookup.php?i=${id}`);
                const data = await response.json();

                if(data.meals){
                    console.log(data.meals);
                    const {
                        idMeal: id,
                        strMealThumb: image,
                        strMeal: name,
                        strInstructions: info,
                        strCategory: cate,
                        strArea: area,
                        strIngredient1,strIngredient2,strIngredient3,strIngredient4,strIngredient5,
                        strIngredient6,strIngredient7,strIngredient8,strIngredient9,strIngredient10,
                        strIngredient11,strIngredient12,strIngredient13,strIngredient14,strIngredient15
                    } = data.meals[0];
                    const ingredients = [strIngredient1,strIngredient2,strIngredient3,strIngredient4,strIngredient5,
                        strIngredient6,strIngredient7,strIngredient8,strIngredient9,strIngredient10,
                        strIngredient11,strIngredient12,strIngredient13,strIngredient14,strIngredient15]
                    const newMeal = {
                        id,
                        name,
                        image,
                        info,
                        cate,
                        area,
                        ingredients
                    }
                    setMeal(newMeal)
                } else {
                    setMeal(null)
                }
            } catch(error) {
                console.log(error)
            }
            setLoading(false);
        }
        getMeal();
    }, [id]);
    if(loading){
        return <h2 className="text-white w-1/2 mx-auto mt-2 h-screen ">
            <img className="bg-white rounded h-10 mx-auto" src={loader} alt="loading" />
        </h2>;
    }
    if(!meal){
        return <h2 className="bg-red-500 text-purple-600 text-2xl rounded rounded-lg">No meal to display...</h2>
    } else {
        const { id,name,image,info,cate,area,ingredients} = meal;
    }
    
    return (
        <section className="">
            <Link to="/" className="text-purple-900 font-mono text-2xl py-3 mx-auto flex flex-col items-center justify-center text-center  
                rounded shadow-lg ">
                <i className="fas fa-arrow-circle-left "></i>
            </Link>
            <div className="grid text-center mx-auto shadow-lg w-screen max-h-screen sm:grid sm:grid-cols-1 sm:grid-rows-3 bg-white rounded sm:grid-flow-col "> 
            <div className="sm:flex sm:items-center sm:justify-center ">
                <img className="w-full h-full object-cover rounded rounded-r-none sm:mx-auto" 
                src={meal.image} 
                alt={meal.name} />
            </div>
            <div className="p-5 relative md:h-1/2 md:w-full sm:w-full sm:h-screen ">
                <h3 className="text-2xl text-purple-700 font-semibold ">How to cook: {meal.name}</h3>
                <p className="my-3 text-gray-700 sm:overflow-y-visible ">
                    {meal.info || meal.info.substring(0,1000)+'...'}
                </p>
                <ul className="flex items-center justify-center mb-5 pb-10 ">
                    <li className="mr-8 w-1/3">
                        <span className="text-grey-700">Category</span>
                        <strong className="block text-purple-700 mb-5">{meal.cate}</strong>
                    </li>
    
                    <li className="flex flex-col items-center justify-center w-2/3 ml-10">
                        <span className="text-grey-700">Ingredients</span>
                        <strong className="flex flex-wrap text-purple-700 ">{meal.ingredients.map((item, idx) => {
                            return item ? <span key={idx}>{item},{'\u00A0'}</span> : null; })} </strong>
                    </li>
                </ul>
            </div>
        </div> 
        </section>
    )
}
